import type { AnyScale } from '../../types/scales.js';
import { isBandScale } from '../../utils/detect-scale.js';
import { GridLines } from './GridLines.js';
import { computeGridLines } from './utils/compute-grid-lines.js';
import { shouldHighlightZeroLine } from './utils/should-highlight-zero-line.js';

export type GridColumnsProps = {
  scale: AnyScale;
  height: number;
  numTicks?: number;
  offset?: number;
  highlightZeroLine?: boolean;
  ticks?: number[];
};

export const GridColumns = ({
  scale,
  height,
  numTicks,
  offset,
  highlightZeroLine = true,
  ticks,
}: GridColumnsProps) => {
  if (ticks) {
    const typedScale = scale as (value: number) => number | undefined;
    const lines = ticks.map((tick, index) => ({
      from: { x: Math.max(0, typedScale(tick) ?? 0), y: 0 },
      to: { x: Math.max(0, typedScale(tick) ?? 0), y: height },
      index,
    }));

    return (
      <GridLines
        lines={lines}
        highlightAccessor={(from, to) =>
          highlightZeroLine &&
          !isBandScale(scale) &&
          shouldHighlightZeroLine(from, to, scale)
        }
      />
    );
  }

  return (
    <GridLines
      lines={computeGridLines(scale, numTicks, offset, height, 'x')}
      highlightAccessor={(from, to) =>
        highlightZeroLine &&
        !isBandScale(scale) &&
        shouldHighlightZeroLine(from, to, scale)
      }
    />
  );
};
